import { makeStyles } from '@surveycake/rc';

export const useStyles = makeStyles([
  [
    'tempSaveButton',
    (theme, [loading]) => [`
      padding: 3px 8px;
      color: #aaaaaa;
      font-size: 14px;
      position: relative;
      display: flex;
      align-items: center;

      span {
        margin-left: 3px;
      }

      & {
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -o-user-select: none;
        user-select: none;
      }

      &:hover {
        cursor: pointer;
        background-color: #eeeeee;
        border-radius: 16px;
      }

      &:active {
        background-color: #d1f0e5;
        color: #3dba90;
      }

      @media (max-width: 720px) {
        max-height: calc(100% - 128px);

        & > .save-label {
          display: none;
        }
      }
    `,
    loading &&
    `
      & > .save-icon {
        opacity: 0.4;
      }

      & > .save-label {
        opacity: 0.4;
      }
    `
    ]
  ],
  [
    'modal',
    `
      width: 320px;
      position: relative;
      display: flex;
      flex-direction: column;
      border-radius: 4px;
      overflow: hidden;

      & > main {
        margin-top: 20px;
      }

      @media (max-width: 720px) {
        width: 100%;
        height: 100%;
      }
    `
  ],
  [
    'header',
    theme => `
      height: 32px;
      padding: 8px 24px;
      background-color: ${theme.color.primary.default};
      display: flex;
      align-items: center;
      justify-content: space-between;

      @media (max-width: 720px) {
        height: 56px;
      }
    `
  ],
  [
    'cross',
    `
      position: relative;
      width: 30px;
      height: 30px;
      border-radius: 15px;

      &::before,
      &::after {
        position: absolute;
        content: '';
        width: 40%;
        height: 2px;
        background-color: #fff;
        top: 50%;
        left: 30%;
      }

      &::before {
        transform: rotate(45deg);
      }

      &::after {
        transform: rotate(-45deg);
      }

      &:hover {
        cursor: pointer;
      }

      &:active {
        background: linear-gradient(20deg,rgba(101,230,190,0.8),rgb(61,186,144,1))
      }
    `
  ],
  [
    'content',
    `
      padding: 8px 24px;
      font-size: 14px;
      color: #454545;
      flex: 1 1 auto;
      line-height: 1.5;
    `
  ],
  [
    'urlContainer',
    `
      display: flex;

      & > input {
        border-radius: 4px;
        border: 1px solid #eeeeee;
        padding-left: 8px;
        padding-right: 8px;
        margin-right: 8px;
        flex: 1;
        cursor: text;
        color: #3dba90;
      }

      & > input:focus {
        outline: none;
      }

      & > .copy-btn {
        font-size: 14px;
        width: 60px;
      }

      @media (max-width: 720px) {
        & > .copy-btn {
          font-size: 16px;
          width: 96px;
        }
      }
    `
  ],
  [
    'footer',
    `
      height: 22px;
      padding-top: 13px;
      padding-bottom: 13px;
      padding-right: 24px;
      background-color: #fafafa;
      border-top: 1px solid #eeeeee;
      text-align: right;

      & > a {
        text-decoration: none;
        color: #3dba90;
        font-size: 14px;
      }

      @media (max-width: 720px) {
        padding-bottom: 40px;
      }
    `
  ],
  [
    'warning',
    `
      display: flex;
      align-items: center;
      margin-top: 18px;
      margin-bottom: 18px;
      font-weight: 500;

      & > svg {
        margin-right: 5px;
      }

      & > svg, & > span {
        color: #f8971d;
      }
    `
  ],
  [
    'spinContainer',
    `
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);

      svg {
        color: #3DBA90;
      }
    `
  ],
  [
    'hiddenIframe',
    `
      visibility: hidden;
      position: absolute;
    `
  ],
]);
